<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5">Dashboard</h1>
    </div>
    <h1 class="is-size-5 is-uppercase" v-if="role === 'admin'">Accounts</h1>
    <div class="columns" v-if="role === 'admin'">
      <div class="column">
        <user-role-card role="all"></user-role-card>
      </div>
      <div class="column">
        <user-role-card role="engineer"></user-role-card>
      </div>
      <div class="column">
        <user-role-card role="admin"></user-role-card>
      </div>
    </div>
    <h1 class="is-size-5 is-uppercase">Requests</h1>
    <div class="columns">
      <div class="column">
        <request-tile type="leave"></request-tile>
      </div>
      <div class="column">
        <request-tile type="travel"></request-tile>
      </div>
      <div class="column">
        <request-tile type="misc"></request-tile>
      </div>
    </div>
    <h1 class="is-size-5 is-uppercase">Service Requests</h1>
    <div class="columns">
      <div class="column">
        <service-request-status-card status="all"></service-request-status-card>
      </div>
      <div class="column">
        <service-request-status-card status="completed"></service-request-status-card>
      </div>
      <div class="column">
        <service-request-status-card status="pending"></service-request-status-card>
      </div>
    </div>
    <h1 class="is-size-5 is-uppercase">Service Types</h1>
    <div class="columns">
      <div class="column">
        <service-request-type-card type="installation"></service-request-type-card>
      </div>
      <div class="column">
        <service-request-type-card type="maintenance"></service-request-type-card>
      </div>
      <div class="column">
        <service-request-type-card type="breakdown"></service-request-type-card>
      </div>
    </div>
    <disk-tile v-if="role === 'admin'"></disk-tile>
  </div>
</template>
<script>
import UserRoleCard from "./components/user-role-card";
import ServiceRequestTypeCard from "./components/service-request-type-card";
import ServiceRequestStatusCard from "./components/service-request-status-card";
import RequestTile from "./components/requests-tile";
import DiskTile from "./components/disk-tile";
export default {
  components: {
    UserRoleCard,
    ServiceRequestTypeCard,
    ServiceRequestStatusCard,
    RequestTile,
    DiskTile
  },
  computed: {
    role() {
      return localStorage.getItem("role");
    }
  }
};
</script>
<style lang="scss">
.dashboard-view-container {
  h1.is-size-3 {
    padding-top: 24px;
  }
  .card {
    cursor: pointer;
    transform: scale(0.98);
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    .card-content {
      .is-flex {
        .card-label {
          flex-basis: 0;
          flex-grow: 1;
        }
      }
    }
    &:hover {
      transform: scale(1);
      box-shadow: 0 0 24px $grey-lighter;
    }
  }
}
</style>
